<template>
  <div id="area-intro">
    <div class="intro">
      <div class="intro-header">
        <div>剑川古城</div>
        <span class="iconfont icon-guanbi" @click="handleCloseIntro"></span>
      </div>
      <div class="intro-text">
        <div class="intro-img-content">
          <img src="../assets/images/jian_chuan.png" alt="剑川封面" />
        </div>
        <div class="text">
          <p>
            剑川古城位于云南省大理白族自治州剑川县，是国家级历史文化名城、云南省历史文化名城，历史文化资源丰富。
          </p>
          <p>
            剑川古城核心保护区面积19.3公顷，包含剑川古城历史文化街区、西门外街历史文化街区、旧寨巷历史文化风貌区、农资公司仓库历史风貌区等保护片区。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AreaIntro',
  methods: {
    /**
     * 关闭详情
     */
    handleCloseIntro() {
      this.$emit('onCloseIntroClick');
    }
  }
};
</script>

<style lang="scss">
#area-intro {
  position: absolute;
  z-index: 100;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  .intro {
    width: 691px;
    max-width: 80vw;
    height: auto;
    max-height: 80vh;
    overflow: auto;
    color: #fff;
    &-header {
      width: 691px;
      max-width: 80vw;
      position: fixed;
      display: flex;
      z-index: 200;
      justify-content: space-between;
      padding: 0 20px;
      font-size: 24px !important;
      font-weight: 500 !important;
      height: 65px;
      line-height: 65px;
      background-color: $primary;
      .iconfont {
        font-size: 24px !important;
        font-weight: 800 !important;
        cursor: pointer;
      }
    }
    &-text {
      display: flex;
      padding: 23px 36px;
      margin-top: 65px;
      background-color: rgba(#000, 0.5);
      img {
        width: 250px;
        height: 293px;
      }
      .text {
        padding: 26px 0 0 53px;
        p {
          line-height: 1.5;
          text-align: justify;
          text-indent: 2em;
        }
      }
    }
  }
}
@media screen and (max-width: 960px) {
  #area-intro {
    z-index: 400;
    .intro-text {
      box-sizing: border-box;
      display: block;
      padding: 10px 20px;
      .intro-img-content {
        display: flex;
        justify-content: center;
        img {
          width: 70vw;
        }
      }
      .text {
        padding: 0;
      }
    }
  }
}
</style>
